import React, {useState, useContext, useRef, Fragment} from 'react';
import {Link} from "react-router-dom";
import __ from "lodash";
import moment from "moment";
import {
  Avatar,
  Button,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Tooltip,
  useTheme,
} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles"
import { yellow } from '@material-ui/core/colors';

import {OpenInBrowser} from "@material-ui/icons";
import SystemContext from "../../../SystemContext";
import Collapse from "react-collapse";
import {
  MaskedText,
  FormMemo,
  RadioButtonGroup,
  MaskedNumber,
  LabelledPaper,
  FormSelect,
  ShcSelect,
  ComboSelect,
  AwbNumber,
  DatePicker,
  FormCheckbox,
  Alert,
  LightTooltip,
  UnNumberSelect
} from '../../../controls';
import Form from "../../../controls/Form";
import FormDialog from "../../../controls/FormDialog";
import BookingValidator from "../validators/BookingValidator";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import CompanyContactLookup from "../../Companies/components/CompanyContactLookup";
import AirportLookup from "../../Airports/components/AirportsLookup";
import AirportNameTooltip from "../../Airports/components/AirportNameTooltip";
import CurrencySelector from "../../Currencies/components/CurrencySelector";
import BookingDimensionsGrid from "./BookingDimensionsGrid";
import BookingRatesGrid from "./BookingRatesGrid";
import BookingDocumentsGrid from "./BookingDocumentsGrid";
import CompanyContacts from "./CompanyContacts";
import {defaultChargeRecord} from "./DefaultChargeRecord";
import FlightOptions from "./FlightOptions";
import {getRates, getCurrencyName, awbNumIsValid} from "../BookingHelperFunctions";
import AwbAllocatedStockLookup from "./AwbAllocatedStockLookup";
import {packBookingRecord, getVolumetricWeight, getChargeableWeight,  getWeightVolumeRatio, forwarderRecord} from "./BookingRecord";
import {useAddBooking, useUpdateBooking} from "../../../services/booking";


const stackableRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  // {label: "Unknown", value: "NONE", disabled: false, size: "small"},
];
const operatorStackable = "ZSK";

const cratedRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  // {label: "Unknown", value: "NONE", disabled: false, size: "small"},
];
const operatorCrated = "ZCT";

const tiltableRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  // {label: "Unknown", value: "NONE", disabled: false, size: "small"},
];
const operatorTiltable = "ZTL";

const dgrRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  {label: "CAO", value: "CAO", disabled: false, size: "small"},
  // {label: "Unkno", value: "NONE", disabled: false, size: "small"},
];
const operatorDgr = "DGR";
const operatorCao = "CAO";

const aviRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  // {label: "Unknown", value: "NONE", disabled: false, size: "small"},
];
const operatorAvi = "AVI";

const outSizedRadioButtons = [
  {label: "Yes", value: "YES", disabled: false, size: "small"},
  {label: "No", value: "NO", disabled: false, size: "small"},
  // {label: "Unknown", value: "NONE", disabled: false, size: "small"},
];
const operatorOutSized = "BIG";

const deliveryStatus = [
  {code: "SECURED", value: "Secured", disabled: true, size: "small"},
  {code: "UNSECURED", value: "Unsecured", disabled: true, size: "small"},
];

const operatorSecure = "ZSD";

const dateFormat = "DD/MM/YYYY";

// Generic utility functions
// =========================

const updateRateLines = (rateLines, acWt, chWt, baseCurrency, baseToUsd) => {

  const freightRecord = { ...defaultChargeRecord, baseRateCurrency: baseCurrency };

  if (rateLines.length === 0)
    rateLines.push(freightRecord);
  rateLines.forEach(rateLine => {
    if (chWt && rateLine.baseRate) {
      rateLine.quantity = chWt;
      rateLine.baseRateTotal =  Number(chWt) * Number(rateLine.baseRate);
      rateLine.usdRateTotal = Number((Math.round(Number(rateLine.baseRateTotal * baseToUsd) * 100) / 100).toFixed(2))
    }
  })

  return rateLines;
};

const getTotals = (rateLines, baseCurrency, baseToEur, baseToGbp) => {
  const totals = {
    eurTotalAmount: 0,
    gbpTotalAmount: 0,
    usdTotalAmount: 0,
  }

  if (rateLines && Array.isArray(rateLines)) {
    let baseRateTotal = 0;
    let usdRateTotal = 0;
    rateLines.forEach(rate => {
      baseRateTotal += (isNaN(rate.baseRateTotal) ? 0 : Number(rate.baseRateTotal));
      usdRateTotal += (isNaN(rate.usdRateTotal) ? 0 : Number(rate.usdRateTotal));
    })

    totals.eurTotalAmount += baseCurrency === "EUR" ? baseRateTotal : baseRateTotal * baseToEur;
    totals.gbpTotalAmount += baseCurrency === "GBP" ? baseRateTotal : baseRateTotal * baseToGbp;
    totals.usdTotalAmount += usdRateTotal;
  }

  return totals;
}

const renderFlightSummary = (record) => {
  const shipmentOrigin = record.originAirportName ? `Shipment origin: ${record.originAirportName}` : "";
  const charterOrigin = record.charterOrigin ? `Flight: ${record.charterOrigin}` : "";
  const destination = record.destination ? `${record.destination}` : "";
  const flightDate = record.flightDate ? `Requested flight date: ${moment(record.flightDate).format("dddd DD/MM/YYYY")}` : "";
  const shipmentDelivery = record.originDelivery ? `Shipment delivery at origin: ${moment(record.originDelivery).format("dddd DD/MM/YYYY")}` : "";

  return (
    <Typography variant="body1" gutterBottom >
      {`${shipmentOrigin} ${charterOrigin} - ${destination} ${flightDate} ${shipmentDelivery}`}
    </Typography>
  )
}

const renderShipmentSummary = (record) => {
  const consolidated = record.consolidation ? "Consolidated Booking - " : "";
  const pieces = record.expectedPieces ? `Pieces: ${record.expectedPieces}, ` : "";
  const weight = record.expectedWeightKg ? `Gross weight: ${(Math.round(record.expectedWeightKg *100) / 100).toFixed(1)}, ` : "";
  const volume = record.expectedVolume ? `Volume: ${(Math.round(record.expectedVolume * 100) / 100).toFixed(2)}, ` : "";
  const volumetricWeight = record.volumetricWeight ? `Volumetric Weight: ${(Math.round(record.volumetricWeight * 100) / 100).toFixed(2)}, ` : "";
  const chargeableWeight = record.expectedChargeableWeight ? `Chargeable Weight: ${(Math.round(record.expectedChargeableWeight * 100) / 100).toFixed(1)}` : "";

  return (
    <Typography variant="body1" gutterBottom >
      {`${consolidated}${pieces}${weight}${volume}${volumetricWeight}${chargeableWeight}`}
    </Typography>
  )
}

const renderDeclarationSummary = (record) => {
  let commodityOrSpecial = "";
  let value = "";
  if (record.commodity && record.commodity === "SL") {
    commodityOrSpecial = "Special Load: ";
    value = record.specialLoad ? record.specialLoad : "";
  } else {
    commodityOrSpecial = "Commodity: ";
    value = record.commodity ? record.commodity : "";
  }
  return (
    <Typography variant="body1" gutterBottom >
      {`${commodityOrSpecial}${value}`}
    </Typography>
  )
}

const renderDocumentsSummary = (record) => {
  const documents = record.documents ? (record.documents) : [];
  let activeDocuments = 0;
  documents.forEach(document => {
    if (document.fileUrl && document.fileUrl) {
      activeDocuments++;
    }
  });

  return (
    <Typography variant="body1" gutterBottom >
      {activeDocuments ? `${activeDocuments} documents have been uploaded` : "There are no documents for this booking" }
    </Typography>
  )
}

const renderSpotRate = (record) => {
  const rate = record.customerTargetRate ? (record.customerTargetRate).toFixed(2) : "";
  const chargeableWeight = `${record.overrideChargeableWeight ? `, Spot Chargeable Weight override: ${record.spotChargeableWeight}KG` : ``}`;
  const offerTargetRate = `${record.offeredSpotRate ? `, Offer spot rate: ${(Math.round(record.offeredSpotRate * 100) / 100).toFixed(2)}` : ``}`;

  return (
    <Typography variant="body1" gutterBottom >
      { record.customerTargetRate ? `Customer Target Rate: ${rate}${chargeableWeight}${offerTargetRate}` : "" }
    </Typography>
  )
}

const renderRatesSummary = (record) => {
  const gbp = record.gbpTotalAmount ? `Total Amount GBP: ${(Math.round(record.gbpTotalAmount *100) / 100).toFixed(2)}, ` : "";
  const eur = record.eurTotalAmount ? `Total Amount EUR: ${(Math.round(record.eurTotalAmount * 100) / 100).toFixed(2)}, ` : "";
  const usd = record.usdTotalAmount ? `Total Amount USD: ${(Math.round(record.usdTotalAmount * 100) / 100).toFixed(2)}, ` : "";

  return (
    <Typography variant="body1" gutterBottom >
      {`Rate summary -  ${eur} ${gbp} ${usd}`}
    </Typography>
  )
}


const renderSpotRateRevenue = (record) => {
  const weight = record.expectedWeightKg ? `Gross weight: ${(Math.round(record.expectedWeightKg *100) / 100).toFixed(1)}KG` : "";
  const volume = record.expectedVolume ? `Volume: ${(Math.round(record.expectedVolume * 100) / 100).toFixed(2)}CBM` : "";
  const volumetricWeight = record.volumetricWeight ? `Volumetric Weight: ${(Math.round(record.volumetricWeight * 100) / 100).toFixed(2)}KG` : "";
  const spotChargeableWeight = !record.overrideChargeableWeight ? record.expectedChargeableWeight : record.spotChargeableWeight;
  const chargeableWeight = spotChargeableWeight ? `${record.overrideChargeableWeight ? "Spot" : ""} Chargeable Weight: ${(Math.round(spotChargeableWeight * 100) / 100).toFixed(1)}KG` : "";
  const rate = record.offeredSpotRate ? (record.offeredSpotRate).toFixed(2) : record.customerTargetRate ? (record.customerTargetRate).toFixed(2) : "";
  const price = spotChargeableWeight ? (Math.round(spotChargeableWeight * rate * 100) / 100).toFixed(0) : ` ??? - ${!record.overrideChargeableWeight ? `missing shipment particulars` : `missing 'Spot Chargebale Weight'`}`;
  let offerToTarget = "";
  let diffPercentage = "";
  if (record.offeredSpotRate && record.customerTargetRate && record.customerTargetRate > 0) {
    if (record.offeredSpotRate > record.customerTargetRate) {
      const diff = record.offeredSpotRate - record.customerTargetRate;
      diffPercentage = Math.round((diff / record.customerTargetRate) * 100).toFixed(1);
      // offerToTarget = ` (Offer rate is ${diffPercentage}% higher than target rate of ${(record.customerTargetRate).toFixed(2)})`;
      offerToTarget = "higher";
    } else {
      const diff = record.customerTargetRate - record.offeredSpotRate;
      diffPercentage = Math.round((diff / record.customerTargetRate) * 100).toFixed(1);
      // offerToTarget = ` (Offer rate is ${diffPercentage}% lower than target rate of ${(record.customerTargetRate).toFixed(2)})`;
      offerToTarget = "lower";
    }
  }

  return (
    <div>
      {record.customerTargetRate
        ?
          <div>
            <div style={{display: "flex", whiteSpace: "pre-wrap"}}>
              <Typography variant="body1" gutterBottom >Total price at </Typography>
              <Typography variant="body1" gutterBottom style={{fontWeight: 900}}>{rate}</Typography>
              <Typography variant="body1" gutterBottom > per KG would be </Typography>
              <Typography variant="body1" gutterBottom style={{fontWeight: 900}}>{price}{record.gsaDefaultCurrencyCode}</Typography>
              {record.offeredSpotRate
                ?
                  <div style={{display: "flex", whiteSpace: "pre-wrap"}}>
                    <Typography variant="body1" gutterBottom> (Offer rate is </Typography>
                    <Typography variant="body1" gutterBottom style={{fontWeight: 900}}>{diffPercentage}%</Typography>
                    <Typography variant="body1" gutterBottom > {offerToTarget}</Typography>
                    <Typography variant="body1" gutterBottom > than target rate of </Typography>
                    <Typography variant="body1" gutterBottom style={{fontWeight: 900}}>{(record.customerTargetRate).toFixed(2)}</Typography>
                    <Typography variant="body1" gutterBottom >).</Typography>
                  </div>
                :
                <></>
              }
            </div>
            <div style={{display: "flex", whiteSpace: "pre-wrap", marginTop: -4}}>
              <Typography variant="body1" gutterBottom >{`(based on ${weight}, ${volume}, ${volumetricWeight}, ${chargeableWeight})`}</Typography>
            </div>
          </div>
        :
          <></>
      }
    </div>
  );
}

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: true,
}


// ===============================================
// THE MAIN COMPONENT
// ===============================================

const BookingForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const NewBookingDialog = props.showFullPage?Form:FormDialog;
  const fullPageStyle = props.fullPageStyle;

  const styles = (theme) => ({
    root: {
      marginTop: 0,
      padding: theme.spacing(2),
    },
    avatar: {
      right: theme.spacing(1),
      top: theme.spacing(1),
      backgroundColor: yellow[200]//theme.palette.grey[900],
    },
  });

  const operatorName = __.startCase(__.toLower(process.env.REACT_APP_COMPANY)) || "Magma";

  const classes = props.classes;
  const defaults = props.defaults;
  const [dialogStates, setDialogStates] = useState(props.dialogStates);
  const [record, setRecord] = useState({
    ...props.record,
    captureParticipants: props.captureParticipants === undefined ? true : props.captureParticipants,
    spotBooking: props.spotBooking,
    formMode: props.formMode,
    strictAwbContent: defaults?.strictAwbContent || false,
    newBooking: props.newBooking || false,
  });
  const [editing, setEditing] = useState(props.newBooking && props.canEdit || false);
  const [newBooking, setNewBooking] = useState(props.newBooking || false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });
  const [dimensionsGridApi, setDimensionsGridApi] = useState(null);
  const [ratesGridApi, setRatesGridApi] = useState(null);
  const [documentsGridApi, setDocumentsGridApi] = useState(null);
  const [titleIcons, setTitleIcons] = useState([]);
  const [collapse, setCollapse] = useState({
    gsa: true,
    participant: true,
    flight: true,
    shipment: true,
    declaration: true,
    documents: true,
    spot: true,
    rates: true,
    info: true,
    confirmation: true,
  });

  const currencies = props.currencies;
  const exchangeRates = props.exchangeRates;
  const terms = props.terms;
  const formMode = props.formMode;
  const managedStock = props.mangedStock || [];
  const captureParticipants = props.captureParticipants === undefined ? true : props.captureParticipants;
  const [spotRequest, setSpotRequest] = useState(props.spotBooking === undefined ? false : props.spotBooking);

  const gsaCompanyRef = useRef();
  const forwarderRef = useRef();
  const shipperRef = useRef();
  const consigneeRef = useRef();
  const awbAllocatedStockRef = useRef();

  if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
    setRecord(props.record);
    setEditing(true);
  }

  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  const handleAddBooking = useAddBooking();
  const handleUpdateBooking = useUpdateBooking();
  const extraKeys = [];

  const formatChars={
    "U": "[A-Z]",
    "A": "[A-Z0-9]",
    "a": "[A-Za-z0-9]",
    "9": "[0-9]",
    "D": "[0-9.]",
    "-": "-",
    "x": "."
  }

  const paperProps = {
    style: {
      backgroundColor: "#f8f8f8",
      boxShadow: 'none',
    }
  }

  const validateShipmentDeclaration = (record, recordChange, property, value) => {
    const data = {
      ...record,
    }
    data[property] = value;
    if (formMode !== "SLR" && !spotRequest) {
      let messagePrefix;
      let checkValue;
      switch(property) {
        case "crated":
        case "stackable":
        case "tiltable":
          messagePrefix = `Non-${property}`;
          checkValue = "NO";
          break;
        case "outSized":
          messagePrefix = "Out Sized";
          checkValue = "YES";
          break;
        case "avi":
          messagePrefix = "Live Animal";
          checkValue = "YES";
          break;
        case "dgr":
          messagePrefix = "Dangerous Goods";
          checkValue = "YES";
          break;
        default:
      }
      const {loading} = defaults;
      if (loading.includes(property) && value === checkValue) {
        SystemData.confirm(
          `${messagePrefix} shipments are outside those allowed for Regular Bookings`,
          `Booking for ${messagePrefix} shipments require spot rate and review by ${operatorName}. Either transfer the booking to a 'Spot Request' by clicking 'YES' or ensure shipment complies with booking T&Cs. Do you wish to transfer this booking to a Spot Request?`,
          [
            {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
            {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
          ],
          async (response) => {
            if (response) {
              setSpotRequest(true);
              recordChange({...data, spotRequest: true});
            }
          }
        );
      } else {
        recordChange(data);
      }
    } else {
      recordChange(data);
    }
  }

  const getButtons = () => {
    if (props.canEdit) {
      if (editing) {
        if (formMode === "SLR")
          return (
            {
              collapse:{icon: "", key: "Collapse", label: "Collapse All", color: "secondary"},
              expand:{icon: "", key: "Expand", label: "Expand All", color: "secondary"},
              save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
              submit:{icon: "check_circle", key: "Submit", label: "Submit & Exit", color: "primary", disabled: (status)=>{return status.error}},
              cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
            }
          );
        else
          return (
            {
              collapse:{icon: "", key: "Collapse", label: "Collapse All", color: "secondary"},
              expand:{icon: "", key: "Expand", label: "Expand All", color: "secondary"},
              save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
              cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"},
            }
          );
      }
      if (newBooking) {
        return (
          {
            collapse:{icon: "", key: "Collapse", label: "Collapse All", color: "secondary"},
            expand:{icon: "", key: "Expand", label: "Expand All", color: "secondary"},
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }
        );
      }
      return (
        {
          collapse:{icon: "", key: "Collapse", label: "Collapse All", color: "secondary"},
          expand:{icon: "", key: "Expand", label: "Expand All", color: "secondary"},
          edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }
      )
    }
    return (
      {
        collapse:{icon: "", key: "Collapse", label: "Collapse All", color: "secondary"},
        expand:{icon: "", key: "Expand", label: "Expand All", color: "secondary"},
        cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
      }
    );
  }

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, icons, ...other } = props;
    return (
      <div>
        <Typography variant="h6">{children}</Typography>
        {icons && Array.isArray(icons) && icons.length > 0 ? (
          <Grid container spacing={2} style={{justifyContent: "center", marginTop: "-51px", marginBottom: "-5px"}}>
            {
              icons.map(icon=> {
                return (
                  <Grid item xs={1}>
                    <Avatar className={classes.avatar}>
                      <Tooltip title={icon.substr(0, icon.indexOf("."))}>
                        <img className={classes.avatar} alt={icon.substr(0, icon.indexOf("."))} src={`images/${icon}`} height={32} width={32}/>
                      </Tooltip>
                    </Avatar>
                  </Grid>
                )
              })
            }
          </Grid>
        ) : null}
      </div>
    );
  });

  const renderFormTitle = (icons, slrFeasibility, slrReference) => {
    if (formMode !== "SLR")
      return (
        <DialogTitle icons={icons}>
          {`${newBooking ? "New" : ""} ${spotRequest ? "Spot Request details": "Booking Request details"} ${dialogStates.awb ? "for " : ""}${dialogStates.awb ? dialogStates.awb : ""}${dialogStates.gsaCompanyName ? ` by ${dialogStates.gsaCompanyName}` : ""} `}
        </DialogTitle>
      );
    return (<DialogTitle icons={icons}>{`${newBooking ? "New" : ""} Special Load Request${slrFeasibility ? ` (${slrFeasibility === "FEASIBILITY" ? "Feasibility Check" : "Confirmed Booking"})${slrReference ?` - ${slrReference}` : ""}`: ""}`}</DialogTitle>)
  }

  const renderBookingDetails = () => {
    return (
      <Grid item xs={12} checkChildren={true}>
        <LabelledPaper
          {...defaultLabelledPaperProps}
          label={formMode === "SLR" ? "Basic Information" : "Booking Details"}
        >
          <FormControl checkChildren={true} key="FC-main" style={{display: "block" }}>
            <FormGroup checkChildren={true} key="FG-main" style={{padding: "8px 8px 8px 8px"}}>
              <Collapse isOpened={collapse.gsa} checkChildren={true}>
                <Grid container checkChildren={true} spacing={2}>
                  {formMode !== "GSSA"
                    ?
                    <Grid item xs={2} checkChildren={true}>
                      <CompanyUuidLookup
                        companyType={formMode === "GSA" ? "GSA" : "CLIENT"}
                        id="gsaCompanyUuid"
                        label="Client / GSA"
                        shrink={true}
                        readOnly={editing!==true || formMode === "GSA"}
                        returnType={"object"}
                        onChange={(returnObject, props) => {
                          if (returnObject.found) {
                            const gsaCompany = returnObject.data
                            const gsaCurrencyRates = getRates(gsaCompany.defaultCurrencyCode, exchangeRates);
                            const {baseToUsd, baseToGbp, baseToEur} = gsaCurrencyRates || {baseToUsd: 0, baseToGbp: 0, baseToEur: 0};
                            if (props.record.rates && props.record.actualWeight && props.record.chargeableWeight) {
                              updateRateLines(props.record.rates, props.record.actualWeight, props.record.chargeableWeight, gsaCompany.defaultCurrencyCode, baseToUsd)
                            }
                            const {eurTotalAmount, gbpTotalAmount, usdTotalAmount} = getTotals(props.record.rates, gsaCompany.defaultCurrencyCode, baseToEur, baseToGbp);

                            const data = {
                              ...props.record,
                              gsaCompanyName: gsaCompany.companyName,
                              gsaCompanyUuid: gsaCompany.companyUuid,
                              gsaDefaultCurrencyCode: gsaCompany.defaultCurrencyCode,
                              gsaDefaultCurrencyName: getCurrencyName(gsaCompany.defaultCurrencyCode, currencies),
                              gsaCurrencyRates: gsaCurrencyRates,
                              eurTotalAmount,
                              gbpTotalAmount,
                              usdTotalAmount,
                              gsaContactUuid: null,
                              gsaContactSalutation: "",
                              gsaContactFirstName: "",
                              gsaContactLastName: "",
                              gsaContactPhone: "",
                              gsaContactEmail: "",
                              gsaCompanyContact: "",
                            }
                            props.recordChange(data);

                            // const contactDetails = gsaCompanyRef.current.getContactDetails();
                            // if (!__.isEmpty(contactDetails)) {
                            //   const data = {
                            //     ...props.record,
                            //     gsaContactUuid: contactDetails.companyContactUuid,
                            //     gsaContactSalutation: contactDetails.title,
                            //     gsaContactFirstName: contactDetails.forename,
                            //     gsaContactLastName: contactDetails.surname,
                            //     gsaContactPhone: contactDetails.phone,
                            //     gsaContactEmail: contactDetails.email,
                            //     gsaCompanyContact: `${contactDetails.title ? contactDetails.title +  " " : ""} ${contactDetails.forename} ${contactDetails.surname}`,
                            //   }
                            //   props.recordChange(data);
                            // }

                          } else {
                            props.onChange(returnObject.value);
                          }
                        }}
                      />
                    </Grid>
                    :
                    <></>
                  }
                  {record => {
                    if (formMode !== "OPERATOR")
                      return (
                        <CompanyContacts
                          companyUuid={record.gsaCompanyUuid}
                          gsa
                          firstName={record.gsaContactFirstName}
                          lastName={record.gsaContactLastName}
                          email={record.gsaContactEmail}
                          ref={gsaCompanyRef}
                          onChange={(contactDetails, props) => {
                            if (!__.isEmpty(contactDetails) && contactDetails.companyContactUuid !== props.record.gsaContactUuid) {
                              const data = {
                                ...props.record,
                                gsaContactUuid: contactDetails.companyContactUuid,
                                gsaContactSalutation: contactDetails.title,
                                gsaContactFirstName: contactDetails.forename,
                                gsaContactLastName: contactDetails.surname,
                                gsaContactPhone: contactDetails.phone,
                                gsaContactEmail: contactDetails.email,
                                gsaCompanyContact: `${contactDetails.title ? contactDetails.title + " " : ""} ${contactDetails.forename ?? ""} ${contactDetails.surname ?? ""} ${contactDetails.email?`(${contactDetails.email})`:``}`,
                              }
                              props.recordChange(data);
                            }
                          }}
                        />)
                  }}
                  {formMode !== "GSSA"
                    ?
                    <Grid item xs={3} checkChildren={true}>
                      <MaskedText
                        id="gsaCompanyName"
                        label="Client / GSA Company"
                        readOnly={true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        mask={"x".repeat(50)}
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                      />
                    </Grid>
                    :
                    <></>
                  }
                  {formMode !== "GSSA" && formMode !== "OPERATOR"
                    ?
                    <Grid item xs={3} checkChildren={true}>
                      <MaskedText
                        id="gsaCompanyContact"
                        label="Booked By"
                        readOnly={true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        mask={"x".repeat(50)}
                        maskChar={""}
                        alwaysShowMask={false}
                        formatChars={formatChars}
                      />
                    </Grid>
                    :
                    <></>
                  }
                  {formMode === "OPERATOR"
                    ?
                    <Grid item xs={3} checkChildren={true}>
                      {(record) => (
                        <CompanyContactLookup
                          id="gsaContactUuid"
                          label="Booked By"
                          shrink={true}
                          companyUuid={record.gsaCompanyUuid}
                          contactType="BOOKING AGENT"
                          returnType="object"
                          onChange={(contactDetails, props) => {
                            if (contactDetails.found) {
                              const data = {
                                ...props.record,
                                gsaContactUuid: contactDetails.data.companyContactUuid,
                                gsaContactSalutation: contactDetails.data.title,
                                gsaContactFirstName: contactDetails.data.forename,
                                gsaContactLastName: contactDetails.data.surname,
                                gsaContactPhone: contactDetails.data.phone,
                                gsaContactEmail: contactDetails.data.email,
                                gsaCompanyContact: contactDetails.data.displayText,
                              }
                              props.recordChange(data);
                            } else {
                              props.onChange(contactDetails.value);
                            }
                          }}
                        />
                      )}
                    </Grid>
                    :
                    <></>
                  }

                  {formMode === "GSSA" ? <Grid item xs={4} key={"gsa-spacer-1"}/> : <></>}

                  <Grid item xs={2} checkChildren={true}>
                    {(record) => (
                      <AwbNumber
                        id="awbNumber"
                        label="Air Waybill Number"
                        readOnly={editing!==true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        prefix={record.awbPrefix}
                        serial={record.awbSerial}
                        //inputProps={defaultEditProps}
                        onChange={(value, props) => {
                          const data = {
                            ...props.record,
                            awbPrefix: value.prefix,
                            awbSerial: value.serial,
                            awbNumber: `${value.prefix}-${value.serial}`
                          }
                          props.recordChange(data);
                          setDialogStates({...dialogStates, awb: `${value.prefix}-${value.serial}`});
                        }}
                      />
                    )}
                    {(record, changeRecord) => (
                      record.awbPrefix && record.awbSerial && record.awbSerial.length > 7 && awbNumIsValid(record.awbSerial) && newBooking && managedStock.includes(record.awbPrefix)
                        ?
                          <AwbAllocatedStockLookup
                            ref={awbAllocatedStockRef}
                            awbPrefix={record.awbPrefix}
                            awbSerial={record.awbSerial}
                            companyUuid={record.gsaCompanyUuid}
                            validateStock={(result) => {
                              if (result && !__.isEmpty(result)) {
                                if (!result.isValid) {
                                  const message = result.message.replace("${}", record.gsaCompanyName ?? "(Client / GSA not selected yet)");
                                  SystemData.confirm(
                                    "Airway Bill Stock Discrepancy",
                                    message,
                                    [
                                      // {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                                      {icon: "cancel", value: false, label: "Clear Airway Bill", options: {color:"secondary"}}
                                    ],
                                    async (response) => {
                                      if (!response) {
                                        changeRecord({awbPrefix: null, awbSerial: null});
                                      }
                                    }
                                  );
                                }
                              }
                            }}
                          />
                        :
                          <></>
                    )}
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <MaskedText
                      id="allotmentCode"
                      label="Allotment Code"
                      inputLabelProps={{shrink: true}}
                      readOnly={editing!==true}
                      fullWidth
                      mask={"x".repeat(50)}
                      maskChar={""}
                      alwaysShowMask={false}
                      forceUpperCase={true}
                      formatChars={formatChars}
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </FormGroup>
          </FormControl>
        </LabelledPaper>
      </Grid>
    );
  }

  const renderAnonymousBasicDetails = () => {
    return (
      <Grid item xs={12} checkChildren={true}>
        <LabelledPaper
          {...defaultLabelledPaperProps}
          label="Basic Information"
        >
          <FormControl checkChildren={true} key="FC-main" style={{display: "block" }}>
            <FormGroup checkChildren={true} key="FG-main" style={{padding: "8px 8px 8px 8px"}}>
              <Collapse isOpened={collapse.gsa} checkChildren={true}>
                <Grid container checkChildren={true} spacing={3}>
                  <Grid item xs={3} checkChildren={true}>
                    <MaskedText
                      id="slrCompanyName"
                      label="Name of Your Company or Client"
                      inputLabelProps={{shrink: true}}
                      fullWidth
                      mask={"x".repeat(50)}
                      maskChar={""}
                      alwaysShowMask={false}
                      formatChars={formatChars}
                    />
                  </Grid>
                  <Grid item xs={3} checkChildren={true}>
                    <MaskedText
                      id="slrContactName"
                      label="Requested By"
                      inputLabelProps={{shrink: true}}
                      fullWidth
                      mask={"x".repeat(50)}
                      maskChar={""}
                      alwaysShowMask={false}
                      formatChars={formatChars}
                      onChange={(value, props)=>{
                        const words = value.split(" ");
                        const upperFirstWords = [];
                        words.forEach(word=> {
                          upperFirstWords.push(__.upperFirst(word));
                        });
                        const data = {
                          ...props.record,
                          slrContactName: upperFirstWords.join(" "),
                        }
                        props.recordChange(data);
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} checkChildren={true}>
                    <MaskedText
                      id="slrContactEmail"
                      label="Email"
                      inputLabelProps={{shrink: true}}
                      fullWidth
                      mask={"x".repeat(500)}
                      maskChar={""}
                      alwaysShowMask={false}
                      formatChars={formatChars}
                    />
                  </Grid>
                  <Grid item xs={1} key={"gsa-spacer-1"}/>
                  <Grid item xs={2} checkChildren={true}>
                    {(record) => (
                      <AwbNumber
                        id="awbNumber"
                        label="Air Waybill Number (if known)"
                        readOnly={editing!==true}
                        inputLabelProps={{shrink: true}}
                        fullWidth
                        prefix={record.awbPrefix}
                        serial={record.awbSerial}
                        //inputProps={defaultEditProps}
                        onChange={(value, props) => {
                          setDialogStates({...dialogStates, awb: `${value.prefix}-${value.serial}`});
                          const data = {
                            ...props.record,
                            awbPrefix: value.prefix,
                            awbSerial: value.serial,
                            awbNumber: `${value.prefix}-${value.serial}`
                          }
                          props.recordChange(data);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Collapse>
            </FormGroup>
          </FormControl>
        </LabelledPaper>
      </Grid>
    );
  }

  const renderShipmentDeclaration = () => {
    return (
      <Grid item xs={12} checkChildren={true}>
        <LabelledPaper {...defaultLabelledPaperProps}
                       label={formMode === "SLR" ? "Cargo Category" : "Shipment Declaration"}
                       isOpened={collapse.declaration}
                       onClick={()=>setCollapse({...collapse, declaration: !collapse.declaration})}
        >
          <FormControl checkChildren={true} key="FC-shipment-declaration" style={{display: "block"}}>
            <FormGroup checkChildren={true} key="FG-shipment-declaration" style={{padding: "8px 8px 8px 8px"}}>
              <Collapse isOpened={collapse.declaration} checkChildren={true}>
                <Grid container checkChildren={true} spacing={3}>
                  {formMode !== "SLR"
                    ?
                    <Grid item xs={3} checkChildren={true}>
                      <FormControl checkChildren={true} style={{display: "block"}}>
                        <ComboSelect
                          id="commodity"
                          label="IATA Commodity Code"
                          inputLabelProps={{ shrink: true }}
                          style={{marginTop: 31}}
                          group="COMMODITY CODES"
                          subGroup="IATA"
                          readOnly={editing!==true}
                          fullWidth
                        />
                      </FormControl>
                    </Grid>
                    :
                    <></>
                  }
                  <Grid item xs={formMode === "SLR" ? 4 : 3} checkChildren={true}>
                    {(record) => (
                      <FormControl checkChildren={true} style={{display: "block"}}>
                        <ComboSelect
                          id="specialLoad"
                          label="Special Load"
                          inputLabelProps={{ shrink: true }}
                          style={{marginTop: 31}}
                          group="SPECIAL LOADS"
                          subGroup="OPERATOR"
                          readOnly={editing!==true || record.commodity !== "SL"}
                          fullWidth
                        />
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item xs={formMode === "SLR" ? 6 : 4} checkChildren={true}>
                    <FormControl checkChildren={true} style={{display: "block"}}>
                      {record =>
                        <ShcSelect
                          id="shcs"
                          label="Special Handling"
                          values={record.shcs || []}
                          readOnly={editing!==true}
                          fullWidth
                          onChange={(values, props) => {
                            const stack = (__.indexOf(values, operatorStackable) !== -1) ? "YES" : props.record.stackable;
                            const tilt = (__.indexOf(values, operatorTiltable) !== -1) ? "YES" : props.record.tiltable;
                            const crate = (__.indexOf(values, operatorCrated) !== -1) ? "YES" : props.record.crated;
                            let dgr = __.indexOf(values, operatorCao) !== -1 ? "CAO" : __.indexOf(values, operatorDgr) !== -1 ? "YES" : props.record.dgr;
                            const avi = (__.indexOf(values, operatorAvi) !== -1) ? "YES" : props.record.avi;
                            const outSized = (__.indexOf(values, operatorOutSized) !== -1) ? "YES" : props.record.outSized;
                            const secure = (__.indexOf(values, operatorSecure) !== -1) ? "SECURED" : props.record.delivery;
                            const data = {
                              ...props.record,
                              stackable: stack,
                              tiltable: tilt,
                              crated: crate,
                              dgr: dgr,
                              avi: avi,
                              outSized: outSized,
                              shcs: values,
                              delivery: secure,
                            }
                            const icons = [...titleIcons];

                            if (formMode !== "SLR" && !spotRequest) {
                              const {shc} = defaults;
                              const nonStandardBooking =  __.intersection(shc, values);
                              if (nonStandardBooking.length > 0) {
                                SystemData.confirm(
                                  "Special Handling Codes outside those allowed for Regular Bookings",
                                  `Booking for shipments containing ${shc} require spot rate and review by ${operatorName}. Either transfer the booking to a 'Spot Request' by clicking 'YES' or select different shipment properties. Do you wish to transfer this booking to a Spot Request?`,
                                  [
                                    {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                                    {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                                  ],
                                  async (response) => {
                                    if (response) {
                                      setSpotRequest(true);
                                      data["spotRequest"] = true;
                                    }
                                  }
                                );
                              }
                            }

                            // if (formMode !== "SLR" && !spotRequest && data.dgr === "CAO") {
                            //   SystemData.confirm(
                            //     "'Cargo aircraft Only' shipments require spot rate",
                            //     `Booking of 'Cargo aircraft Only' shipments require spot rate and review by Magma. Either transfer the booking to a 'Spot Request' by clicking 'YES' or select different shipment properties. Do you wish to transfer this booking to a Spot Request?`,
                            //     [
                            //       {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                            //       {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                            //     ],
                            //     async (response) => {
                            //       if (response) {
                            //         setSpotRequest(true);
                            //         data["spotRequest"] = true;
                            //       }
                            //       else {
                            //         data.dgr = "NONE";
                            //         dgr = "NONE";
                            //         props.recordChange(data);
                            //         const caoShcIndex = data.shcs.indexOf("CAO");
                            //         if (caoShcIndex > -1) { data.shcs.splice(caoShcIndex, 1); }
                            //         const caoIndex = icons.indexOf("cao.svg");
                            //         if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                            //         setTitleIcons(icons);
                            //       }
                            //     }
                            //   );
                            // }

                            if (dgr === "CAO" && !titleIcons.includes("cao.svg")) {
                              icons.push("cao.svg");
                              const index = icons.indexOf("dgr.png");
                              if (index > -1) { icons.splice(index, 1); }
                              setTitleIcons(icons);
                            }
                            else if (dgr === "YES" && !titleIcons.includes("dgr.png")) {
                              icons.push("dgr.png");
                              const caoIndex = icons.indexOf("cao.svg");
                              if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                              setTitleIcons(icons);
                            }
                            else if (dgr !== "CAO" && dgr !== "YES") {
                              const index = icons.indexOf("dgr.png");
                              if (index > -1) { icons.splice(index, 1); }
                              const caoIndex = icons.indexOf("cao.svg");
                              if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                              setTitleIcons(icons);
                            }
                            props.recordChange(data);
                          }}
                        />
                      }
                    </FormControl>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <FormSelect
                      id="delivery"
                      label="Delivery Status"
                      options={deliveryStatus ? deliveryStatus : null}
                      readOnly={editing!==true}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="Stackable">
                      <FormGroup checkChildren={true} key="FG-Stackable" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id="stackable"
                          key="RBG-stackable"
                          buttons={stackableRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            validateShipmentDeclaration(props.record, props.recordChange, "stackable", value);
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="Crated">
                      <FormGroup checkChildren={true} key="FG-Crated" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id="crated"
                          key="RBG-crated"
                          buttons={cratedRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            validateShipmentDeclaration(props.record, props.recordChange, "crated", value);
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="Tiltable">
                      <FormGroup checkChildren={true} key="FG-Tiltable" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id={"tiltable"}
                          key="RBG-tiltable"
                          buttons={tiltableRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            validateShipmentDeclaration(props.record, props.recordChange, "tiltable", value);
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="Out Sized">
                      <FormGroup checkChildren={true} key="FG-Outsized" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id={"outSized"}
                          key="RBG-outsized"
                          buttons={outSizedRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            validateShipmentDeclaration(props.record, props.recordChange, "outSized", value);
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="Live Animals">
                      <FormGroup checkChildren={true} key="FG-AVI" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id={"avi"}
                          key="RBG-avi"
                          buttons={aviRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            validateShipmentDeclaration(props.record, props.recordChange, "avi", value);
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  <Grid item xs={2} checkChildren={true}>
                    <LabelledPaper checkChildren={true} label="DGR">
                      <FormGroup checkChildren={true} key="FG-DGR" style={{padding: "0px 8px 0px 8px"}}>
                        <RadioButtonGroup
                          id={"dgr"}
                          key="RBG-dgr"
                          buttons={dgrRadioButtons}
                          readOnly={editing!==true}
                          onChange={(value, props) => {
                            const icons = [...titleIcons];
                            // if (formMode !== "SLR" && !spotRequest && value === "CAO") {
                            //   SystemData.confirm(
                            //     "'Cargo aircraft Only' booking require spot rate",
                            //     `Booking of 'Cargo aircraft Only' shipments require spot rate and review by Magma. Either transfer the booking to a 'Spot Request' by clicking 'YES' or select different shipment properties. Do you wish to transfer this booking to a Spot Request?`,
                            //     [
                            //       {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                            //       {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                            //     ],
                            //     async (response) => {
                            //       if (response) {
                            //         setSpotRequest(true);
                            //       }
                            //       else {
                            //         value = "NONE";
                            //         const data = {
                            //           ...props.record,
                            //           dgr: value,
                            //         }
                            //         const caoIndex = icons.indexOf("cao.svg");
                            //         if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                            //         setTitleIcons(icons);
                            //         props.recordChange(data);
                            //       }
                            //     }
                            //   );
                            // }

                            const data = {
                              ...props.record,
                              dgr: value,
                            }

                            if (value === "CAO" && !titleIcons.includes("cao.svg")) {
                              const icons = [...titleIcons];
                              icons.push("cao.svg");
                              const index = icons.indexOf("dgr.png");
                              if (index > -1) { icons.splice(index, 1); }
                              setTitleIcons(icons);
                              const shcs = props.record.shcs || [];
                              if (!shcs.includes("DGR"))
                                shcs.push("DGR");
                              if (!shcs.includes("CAO"))
                                shcs.push("CAO");
                              data["shcs"] = shcs;
                            }
                            else if (value === "YES" && !titleIcons.includes("dgr.png")) {
                              icons.push("dgr.png");
                              const caoIndex = icons.indexOf("cao.svg");
                              if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                              setTitleIcons(icons);
                              const shcs = props.record.shcs || [];
                              if (!shcs.includes("DGR"))
                                shcs.push("DGR");
                              data["shcs"] = shcs;
                            } else if (value !== "CAO" && value !== "YES"){
                              const index = icons.indexOf("dgr.png");
                              if (index > -1) { icons.splice(index, 1); }
                              const caoIndex = icons.indexOf("cao.svg");
                              if (caoIndex > -1) { icons.splice(caoIndex, 1); }
                              setTitleIcons(icons);
                              const shcs = props.record.shcs || [];
                              if (shcs.includes("CAO"))
                                shcs.splice(shcs.indexOf("CAO"), 1);
                              data["shcs"] = shcs;
                            }
                            props.recordChange(data);
                            if (eventBus && ratesGridApi) {
                              setTimeout(function() {
                                eventBus.trigger('Rates.add', {gridApi: ratesGridApi, dgr: value});
                              }, 500);
                            }
                          }}
                        />
                      </FormGroup>
                    </LabelledPaper>
                  </Grid>
                  {(record) => (
                    record.dgr === "CAO" || record.dgr === "YES"
                      ?
                        <Grid item xs={record.unNumbers && Array.isArray(record.unNumbers) && record.unNumbers.includes("1845") ? 6 : 12} checkChildren={true}>
                          <FormControl checkChildren={true} style={{display: "block"}}>
                            {record =>
                              <UnNumberSelect
                                id="unNumbers"
                                label={`DG Compounds (UN Numbers) - ${operatorName} can not carry ${defaults?.restrictedUnNumbers}`}
                                values={record.unNumbers || []}
                                onChange={(values, props) => {
                                  const {restrictedUnNumbers} = defaults || {restrictedUnNumbers: []};
                                  const restrictedNumbers = restrictedUnNumbers.join(",").replaceAll("UN","").split(",");
                                  if (__.intersectionBy(values, restrictedNumbers, Number).length > 0) {
                                    SystemData.alert("Error", `${operatorName} cannot carry these UN numbers: ${restrictedUnNumbers}`);
                                    values = __.difference(values, restrictedNumbers);
                                  }
                                  let quantityOfUnNumber = props?.record.quantityOfUnNumber;
                                  if (!values.includes("1845")) {
                                    quantityOfUnNumber = 0.0;
                                  }
                                  const data = {
                                    ...props.record,
                                    unNumbers: values,
                                    quantityOfUnNumber,
                                  }
                                  props.recordChange(data);
                                }}
                              />
                            }
                          </FormControl>
                        </Grid>
                      :
                        <></>
                  )}
                  {(record) => (
                    record.unNumbers && Array.isArray(record.unNumbers) && record.unNumbers.includes("1845")
                      ?
                        <Grid item xs={6} checkChildren={true}>
                          <MaskedNumber
                            id="quantityOfUnNumber"
                            label="Dry Ice Quantity"
                            readOnly={editing !== true}
                            inputLabelProps={{shrink: true}}
                            fullWidth
                            onChange={(value, props) => {
                              const {maxDryIce} = defaults;
                              if (value > maxDryIce) {
                                SystemData.alert("Error", `${value} exceeds the maximum allowed quantity of ${maxDryIce} kg of dry ice.`);
                                value = 0.0;
                              }
                              const data = {
                                ...props.record,
                                quantityOfUnNumber: value,
                              }
                              props.recordChange(data);
                            }}
                          />
                        </Grid>
                      :
                        <></>
                  )}
                  <Grid item xs={6} checkChildren={true}>
                    <FormMemo
                      id="specialInformation"
                      label="Special Information"
                      readOnly={editing!==true}
                      shrink={true}
                    />
                  </Grid>
                  {/*<Grid item xs={12} key={"cargo-spacer-1"}/>*/}
                  <Grid item xs={6} checkChildren={true}>
                    <FormMemo
                      id="cargoDescription"
                      label="Cargo Description"
                      readOnly={editing!==true}
                      shrink={true}
                    />
                  </Grid>
                </Grid>
              </Collapse>
              {!collapse.declaration
                ? (record) => (<div>{renderDeclarationSummary(record)}</div>)
                : <></>
              }
            </FormGroup>
          </FormControl>
        </LabelledPaper>
      </Grid>

    );
  }

  if (record.bookingType === "E-BOOKING" && !titleIcons.includes("bolt.png"))
    titleIcons.push("bolt.png");
  if (record.bookingStatus === "CANCELLED" && !titleIcons.includes("Cancel.png"))
    titleIcons.push("Cancel.png");

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>
      {record ?
        <NewBookingDialog
          key="booking form"
          formId={"booking form"}
          title={renderFormTitle(titleIcons, record.slrFeasibility, record.slrReference) || ""}
          message=""
          open={dialogStates.showDialog}
          dialogOptions={{maxWidth: "lg", fullWidth: true, PaperProps: paperProps }}
          record={record}
          validator={editing?BookingValidator:undefined}
          validatorPosition="top"
          alert={alert}
          formHeightOffset={props.formHeightOffset||320}
          titleBarStyle={record.bookingStatus === "CANCELLED" ?  {backgroundColor: '#f1f1f1', color: theme.palette.primary.main} :  {backgroundColor: '#3f3f3f', color: theme.palette.primary.main}}
          buttonBarStyleOverride={{position: "relative", width: "calc(100% - 15px)", backgroundColor: "#ffffff", borderTop: `1px solid ${props.fullPageStyle?"grey":"lightgrey"}`, ...props.fullPageStyle}}
          formBodyStyle={{...props.fullPageStyle}}
          style={{...props.fullPageStyle}}
          buttons={getButtons()}
          onChange={(state) => {
            if (state.buttonPressed === "collapse") {
              setCollapse({
                gsa: true,
                participant: false,
                flight: false,
                shipment: false,
                declaration: false,
                documents: false,
                spot: false,
                rates: false,
                info: false,
                confirmation: false,
              });
            }
            if (state.buttonPressed === "expand") {
              setCollapse({
                gsa: true,
                participant: true,
                flight: true,
                shipment: true,
                declaration: true,
                documents: true,
                spot: true,
                rates: true,
                info: true,
                confirmation: true,
              });
            }
            if (state.buttonPressed === "edit" && props.canEdit) {
              setEditing(true);
            }
            if (state.buttonPressed === "cancel") {
              setEditing(false);
              setRecord(props.record);
              setDialogStates({showDialog: false});
              if (props.close)
                props.close();
            }
            if (state.buttonPressed === "save" || state.buttonPressed === "submit") {
              SystemData.toggleLoadingProgress(true);
              const bookingType = spotRequest ? "SPOT" : formMode === "SLR" ? "SPECIAL LOAD" : "CONTRACT";
              const record = {...state.record, bookingType};
              const packedBooking = packBookingRecord(record);
              const handledObject = spotRequest ? "Spot Request" : formMode === "SLR" ? "Special load Request" : "Booking";

              if (newBooking) {
                handleAddBooking.mutate({
                  extraKeys,
                  record: packedBooking,
                  postSuccess: () => {
                    setEditing(false);
                    setNewBooking(false);
                    SystemData.toggleLoadingProgress(false);
                    setAlert({ severity: "info", open: true, message: `New ${handledObject} saved`, timeOut: 5 });
                    if (state.buttonPressed === "submit") {
                      setEditing(false);
                      setDialogStates({showDialog: false});
                      if (props.close)
                        props.close();
                    }
                  },
                  postError: (data) => {
                    SystemData.toggleLoadingProgress(false);
                    if (data.errorMessage) {
                      SystemData.alert("Error", `${data.errorMessage}`);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred saving the ${handledObject}`);
                    }
                  }
                });
              } else {
                handleUpdateBooking.mutate({
                  extraKeys,
                  record: packedBooking,
                  postSuccess: () => {
                    setEditing(false);
                    SystemData.toggleLoadingProgress(false);
                    setAlert({ severity: "info", open: true, message: `${handledObject} Record Updated`, timeOut: 5 });
                    getButtons();
                  },
                  postError: (data) => {
                    SystemData.toggleLoadingProgress(false);
                    if (data.errorMessage) {
                      SystemData.alert("Error", `${data.errorMessage}`);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred updating the ${handledObject}`);
                    }
                  }
                });
                SystemData.toggleLoadingProgress(false);
              }
            } else {
            }
          }}
        >
          <Grid container checkChildren={true} spacing={3}>

            {/*GSA & AWB*/}
            {formMode === "SLR" ? renderAnonymousBasicDetails() : renderBookingDetails()}

            {/*Forwarder, Shipper, Consignee*/}
            {captureParticipants
              ?
              <Grid item xs={4} checkChildren={true}>
                <LabelledPaper {...defaultLabelledPaperProps}
                               label="Forwarder"
                               isOpened={collapse.participant}
                               onClick={()=>setCollapse({...collapse, participant: !collapse.participant})}
                >
                  <FormControl checkChildren={true} key="FC-forwarder" style={{display: "block"}}>
                    <FormGroup checkChildren={true} key="FG-forwarder" style={{padding: "8px 8px 8px 8px"}}>
                      <Collapse isOpened={collapse.participant} checkChildren={true}>
                        <Grid container checkChildren={true} spacing={3}>
                          <Grid item xs={12} checkChildren={true}>
                            <CompanyUuidLookup
                              companyType={"CLIENT"}
                              id="forwarderCompanyUuid"
                              label="Select Forwarder Company"
                              shrink
                              readOnly={editing !== true}
                              returnType={"object"}
                              includeNew={true}
                              onChange={(returnObject, props) => {
                                if (returnObject.found) {
                                  const forwarder = returnObject.data
                                  const forwarderCompany = forwarder.companyCode === "NEW FORWARDER" ? "" : forwarder.companyName;
                                  const data = {
                                    ...props.record,
                                    forwarderCompanyName: forwarderCompany,
                                    forwarderCompanyUuid: forwarder.companyUuid,
                                    forwarderIsNew: forwarder.companyCode === "NEW FORWARDER",
                                    forwarderContactUuid: "",
                                    forwarderSalutation: "",
                                    forwarderFirstName: "",
                                    forwarderLastName: "",
                                    forwarderPhone: "",
                                    forwarderAltPhone: "",
                                    forwarderEmail: "",
                                  }
                                  props.recordChange(data);

                                  // const contactDetails = forwarderRef.current.getContactDetails();
                                  // if (!__.isEmpty(contactDetails)) {
                                  //   const data = {
                                  //     ...props.record,
                                  //     forwarderSalutation: contactDetails.title,
                                  //     forwarderFirstName: contactDetails.forename,
                                  //     forwarderLastName: contactDetails.surname,
                                  //     forwarderPhone: contactDetails.phone,
                                  //     forwarderAltPhone: contactDetails.altPhone,
                                  //     forwarderEmail: contactDetails.email,
                                  //   }
                                  //   props.recordChange(data);
                                  // }
                                } else {
                                  props.onChange(returnObject.value);
                                }
                              }}
                            />
                            {record => (
                              <CompanyContacts
                                companyUuid={record.forwarderCompanyUuid}
                                ref={forwarderRef}
                                onChange={(contactDetails, props) => {
                                  if (!__.isEmpty(contactDetails) && contactDetails.companyContactUuid !== props.record.forwarderContactUuid) {
                                    const data = {
                                      ...props.record,
                                      forwarderContactUuid: contactDetails.companyContactUuid,
                                      forwarderSalutation: contactDetails.title,
                                      forwarderFirstName: contactDetails.forename,
                                      forwarderLastName: contactDetails.surname,
                                      forwarderPhone: contactDetails.phone,
                                      forwarderAltPhone: contactDetails.altPhone,
                                      forwarderEmail: contactDetails.email,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            {record => (
                              <MaskedText
                                id="forwarderCompanyName"
                                label="Forwarder Company Name"
                                readOnly={editing !== true || (record.forwarderCompanyUuid && !record.forwarderIsNew)}
                                inputLabelProps={{shrink: true}}
                                fullWidth
                                mask={"x".repeat(50)}
                                maskChar={""}
                                forceSentenceCase={true}
                                alwaysShowMask={false}
                                formatChars={formatChars}
                              />
                            )}
                          </Grid>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedText
                              id="forwarderSalutation"
                              label="Salutation"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="forwarderFirstName"
                              label="First Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="forwarderLastName"
                              label="Last Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="forwarderPhone"
                              label="Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="forwarderAltPhone"
                              label="Alternate Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            <MaskedText
                              id="forwarderEmail"
                              label="Email Address"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                        </Grid>
                      </Collapse>
                      {!collapse.participant
                        ? (record) => (<div> {record.forwarderCompanyName} </div>)
                        : <></>
                      }
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              :
              <></>
            }
            {captureParticipants
              ?
              <Grid item xs={4} checkChildren={true}>
                <LabelledPaper {...defaultLabelledPaperProps}
                               label="Shipper"
                               isOpened={collapse.participant}
                               onClick={()=>setCollapse({...collapse, participant: !collapse.participant})}
                >
                  <FormControl checkChildren={true} key="FC-shipper" style={{display: "block"}}>
                    <FormGroup checkChildren={true} key="FG-shipper" style={{padding: "8px 8px 8px 8px"}}>
                      <Collapse isOpened={collapse.participant} checkChildren={true}>
                        <Grid container checkChildren={true} spacing={3}>
                          <Grid item xs={12} checkChildren={true}>
                            <CompanyUuidLookup
                              companyType={"SHIPPER"}
                              id="shipperCompanyUuid"
                              label="Select Shipper Company"
                              shrink
                              readOnly={editing !== true}
                              returnType={"object"}
                              includeNew={true}
                              onChange={(returnObject, props) => {
                                if (returnObject.found) {
                                  const shipper = returnObject.data
                                  const shipperCompany = shipper.companyCode === "NEW SHIPPER" ? "" : shipper.companyName;
                                  const data = {
                                    ...props.record,
                                    shipperCompanyName: shipperCompany,
                                    shipperCompanyUuid: shipper.companyUuid,
                                    shipperIsNew: shipper.companyCode === "NEW SHIPPER",
                                    shipperContactUuid: "",
                                    shipperSalutation: "",
                                    shipperFirstName: "",
                                    shipperLastName: "",
                                    shipperPhone: "",
                                    shipperAltPhone: "",
                                    shipperEmail: "",
                                  }
                                  props.recordChange(data);

                                  // const contactDetails = shipperRef.current.getContactDetails();
                                  // if (!__.isEmpty(contactDetails)) {
                                  //   const data = {
                                  //     ...props.record,
                                  //     shipperSalutation: contactDetails.title,
                                  //     shipperFirstName: contactDetails.forename,
                                  //     shipperLastName: contactDetails.surname,
                                  //     shipperPhone: contactDetails.phone,
                                  //     shipperAltPhone: contactDetails.altPhone,
                                  //     shipperEmail: contactDetails.email,
                                  //   }
                                  //   props.recordChange(data);
                                  // }
                                } else {
                                  props.onChange(returnObject.value);
                                }
                              }}
                            />
                            {record => (
                              <CompanyContacts
                                companyUuid={record.shipperCompanyUuid}
                                ref={shipperRef}
                                onChange={(contactDetails, props) => {
                                  if (!__.isEmpty(contactDetails) && contactDetails.companyContactUuid !== props.record.shipperContactUuid) {
                                    const data = {
                                      ...props.record,
                                      shipperContactUuid: contactDetails.companyContactUuid,
                                      shipperSalutation: contactDetails.title,
                                      shipperFirstName: contactDetails.forename,
                                      shipperLastName: contactDetails.surname,
                                      shipperPhone: contactDetails.phone,
                                      shipperAltPhone: contactDetails.altPhone,
                                      shipperEmail: contactDetails.email,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            <MaskedText
                              id="shipperCompanyName"
                              label="Shipper Company"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(50)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedText
                              id="shipperSalutation"
                              label="Salutation"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="shipperFirstName"
                              label="First Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="shipperLastName"
                              label="Last Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="shipperPhone"
                              label="Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="shipperAltPhone"
                              label="Alternate Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            <MaskedText
                              id="shipperEmail"
                              label="emailAddress"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                        </Grid>
                      </Collapse>
                      {!collapse.participant
                        ? (record) => (<div> {record.shipperCompanyName} </div>)
                        : <></>
                      }
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              :
              <></>
            }
            {captureParticipants
              ?
              <Grid item xs={4} checkChildren={true}>
                <LabelledPaper {...defaultLabelledPaperProps}
                               label="Consignee"
                               isOpened={collapse.participant}
                               onClick={()=>setCollapse({...collapse, participant: !collapse.participant})}
                >
                  <FormControl checkChildren={true} key="FC-consignee" style={{display: "block"}}>
                    <FormGroup checkChildren={true} key="FG-consignee" style={{padding: "8px 8px 8px 8px"}}>
                      <Collapse isOpened={collapse.participant} checkChildren={true}>
                        <Grid container checkChildren={true} spacing={3}>
                          <Grid item xs={12} checkChildren={true}>
                            <CompanyUuidLookup
                              companyType={"CONSIGNEE"}
                              id="consigneeCompanyUuid"
                              label="Select Consignee Company"
                              shrink
                              readOnly={editing !== true}
                              returnType={"object"}
                              includeNew={true}
                              onChange={(returnObject, props) => {
                                if (returnObject.found) {
                                  const consignee = returnObject.data
                                  const consigneeCompany = consignee.companyCode === "NEW CONSIGNEE" ? "" : consignee.companyName;
                                  const data = {
                                    ...props.record,
                                    consigneeCompanyName: consigneeCompany,
                                    consigneeCompanyUuid: consignee.companyUuid,
                                    consigneeIsNew: consignee.companyCode === "NEW CONSIGNEE",
                                    consigneeContactUuid: "",
                                    consigneeSalutation: "",
                                    consigneeFirstName: "",
                                    consigneeLastName: "",
                                    consigneePhone: "",
                                    consigneeAltPhone: "",
                                    consigneeEmail: "",
                                  }
                                  props.recordChange(data);

                                  // const contactDetails = consigneeRef.current.getContactDetails();
                                  // if (!__.isEmpty(contactDetails)) {
                                  //   const data = {
                                  //     ...props.record,
                                  //     consigneeSalutation: contactDetails.title,
                                  //     consigneeFirstName: contactDetails.forename,
                                  //     consigneeLastName: contactDetails.surname,
                                  //     consigneePhone: contactDetails.phone,
                                  //     consigneeAltPhone: contactDetails.altPhone,
                                  //     consigneeEmail: contactDetails.email,
                                  //   }
                                  //   props.recordChange(data);
                                  // }
                                } else {
                                  props.onChange(returnObject.value);
                                }
                              }}
                            />
                            {record => (
                              <CompanyContacts
                                companyUuid={record.consigneeCompanyUuid}
                                ref={consigneeRef}
                                onChange={(contactDetails, props) => {
                                  if (!__.isEmpty(contactDetails) && contactDetails.companyContactUuid !== props.record.consigneeContactUuid) {
                                    const data = {
                                      ...props.record,
                                      consigneeContactUuid: contactDetails.companyContactUuid,
                                      consigneeSalutation: contactDetails.title,
                                      consigneeFirstName: contactDetails.forename,
                                      consigneeLastName: contactDetails.surname,
                                      consigneePhone: contactDetails.phone,
                                      consigneeAltPhone: contactDetails.altPhone,
                                      consigneeEmail: contactDetails.email,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            <MaskedText
                              id="consigneeCompanyName"
                              label="Consignee Company"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(50)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedText
                              id="consigneeSalutation"
                              label="Salutation"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="consigneeFirstName"
                              label="First Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={5} checkChildren={true}>
                            <MaskedText
                              id="consigneeLastName"
                              label="Last Name"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              forceSentenceCase={true}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="consigneePhone"
                              label="Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={6} checkChildren={true}>
                            <MaskedNumber
                              id="consigneeAltPhone"
                              label="Alternate Phone Number"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              format="+##############"
                            />
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            <MaskedText
                              id="consigneeEmail"
                              label="emailAddress"
                              readOnly={editing !== true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                        </Grid>
                      </Collapse>
                      {!collapse.participant
                        ? (record) => (<div> {record.consigneeCompanyName} </div>)
                        : <></>
                      }
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              :
              <></>
            }

            {/*Shipment Declaration in SLR mode */}
            {formMode === "SLR" ? renderShipmentDeclaration() : <></> }

            {/*Flight*/}
            <Grid item xs={12} checkChildren={true} >
              <LabelledPaper {...defaultLabelledPaperProps}
                             label="Flight"
                             isOpened={collapse.flight}
                             onClick={()=>setCollapse({...collapse, flight: !collapse.flight})}
              >
                <FormControl checkChildren={true} key="FC-flight" style={{display: "block"}}>
                  <FormGroup checkChildren={true} key="FG-flight" style={{padding: "8px 8px 8px 8px"}}>
                    <Collapse isOpened={collapse.flight} checkChildren={true}>
                      <Grid container checkChildren={true} spacing={3}>
                        <Grid item xs={1} checkChildren={true} >
                          <AirportLookup
                            key={"origin"}
                            id="origin"
                            label={"Origin"}
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            readOnly={editing!==true}
                            value={record.airportCode}
                            returnType={"object"}
                            onChange={(returnObject, props) => {
                              if (returnObject.found) {
                                const originAirport = returnObject.data
                                const data = {
                                  ...props.record,
                                  origin: originAirport.airportCode,
                                  //originAirportName: originAirport.airportName,
                                }
                                props.recordChange(data);
                              } else {
                                props.onChange(returnObject.value);
                              }
                            }}
                          />
                          {record=>
                            record.origin
                              ?
                              <AirportNameTooltip
                                airportCode={record.origin}
                                onChange={(airport, props)=> {
                                  if (!__.isEmpty(airport) && airport.airportName !== props.record.originAirportName) {
                                    const data = {
                                      ...props.record,
                                      originAirportName: airport.airportName,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                              :
                              <></>
                          }
                        </Grid>
                        <Grid item xs={3} checkChildren={true} >
                          <MaskedText
                            id="originAirportName"
                            label="Origin Airport Name"
                            readOnly={true}
                            inputLabelProps={{shrink: true}}
                            fullWidth
                            mask={"x".repeat(100)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                          />
                        </Grid>
                        <Grid item xs={1} checkChildren={true} >
                          <AirportLookup
                            key={"magmaOrigin"}
                            id="charterOrigin"
                            label={"Departure"}
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            readOnly={editing!==true}
                            value={record.airportCode}
                            returnType={"object"}
                            onChange={(returnObject, props) => {
                              if (returnObject.found) {
                                const originAirport = returnObject.data
                                const data = {
                                  ...props.record,
                                  charterOrigin: originAirport.airportCode,
                                  //charterOriginName: originAirport.airportName,
                                }
                                props.recordChange(data);
                              } else {
                                props.onChange(returnObject.value);
                              }
                            }}
                          />
                          {record=>
                            record.charterOrigin
                              ?
                              <AirportNameTooltip
                                airportCode={record.charterOrigin}
                                onChange={(airport, props)=> {
                                  if (!__.isEmpty(airport) && airport.airportName !== props.record.charterOriginName) {
                                    const data = {
                                      ...props.record,
                                      charterOriginName: airport.airportName,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                              :
                              <></>
                          }
                        </Grid>
                        <Grid item xs={3} checkChildren={true} >
                          <MaskedText
                            id="charterOriginName"
                            label={`${operatorName} Point of Departure Airport Name`}
                            readOnly={true}
                            inputLabelProps={{shrink: true}}
                            fullWidth
                            mask={"x".repeat(100)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                          />
                        </Grid>
                        <Grid item xs={1} checkChildren={true} >
                          <AirportLookup
                            id="destination"
                            label={"Destination"}
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            readOnly={editing!==true}
                            value={record.airportCode}
                            returnType={"object"}
                            onChange={(returnObject, props) => {
                              if (returnObject.found) {
                                //TODO: need to link Terms to flight origin/destination
                                const destinationAirport = returnObject.data
                                const routeTerms = __.find(terms, {code:"GENERAL"}).value || {prompt: "", url: ""};
                                const {prompt, url} = routeTerms;
                                const data = {
                                  ...props.record,
                                  destination: destinationAirport.airportCode,
                                  //destinationName: destinationAirport.airportName,
                                  terms: prompt,
                                  termsUrl: url,
                                }
                                props.recordChange(data);
                              } else {
                                props.onChange(returnObject.value);
                              }
                            }}
                          />
                          {record=>
                            record.destination
                              ?
                              <AirportNameTooltip
                                airportCode={record.destination}
                                onChange={(airport, props)=> {
                                  if (!__.isEmpty(airport) && airport.airportName !== props.record.destinationName) {
                                    const routeTerms = __.find(terms, {code:"GENERAL"}).value || {prompt: "", url: ""};
                                    const {prompt, url} = routeTerms;
                                    const data = {
                                      ...props.record,
                                      destinationName: airport.airportName,
                                      terms: prompt,
                                      termsUrl: url,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                              :
                              <></>
                          }
                        </Grid>
                        <Grid item xs={3} checkChildren={true} >
                          <MaskedText
                            id="destinationName"
                            label="Destination Airport Name"
                            readOnly={true}
                            inputLabelProps={{shrink: true}}
                            fullWidth
                            mask={"x".repeat(100)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                          />
                        </Grid>
                        <Grid item xs={12} key={"flight-spacer-1"}/>
                        {/*<Grid item xs={4} checkChildren={true} >*/}
                        {/*  {record=>(*/}
                        {/*    <FormControl checkChildren={true} style={{display: "block"}}>*/}
                        {/*      <TripAvailableFlights*/}
                        {/*        id="flightDate"*/}
                        {/*        label="Requested Flight Date"*/}
                        {/*        searchValues={[record.charterOrigin, record.destination, null]}*/}
                        {/*        readOnly={editing!==true}*/}
                        {/*        fullWidth*/}
                        {/*        onChange={(returnValue, props) => {*/}
                        {/*          const data = {*/}
                        {/*            ...props.record,*/}
                        {/*            flightDate: returnValue,*/}
                        {/*            originDelivery: moment(returnValue).add(-3,'days').format("YYYY-MM-DD")*/}
                        {/*          }*/}
                        {/*          props.recordChange(data);*/}
                        {/*        }}*/}
                        {/*      />*/}
                        {/*    </FormControl>*/}
                        {/*  )}*/}
                        {/*</Grid>*/}
                        <Grid item xs={4} checkChildren={true} >
                          {record=> (
                            <div style={{display: "flex"}}>
                              <DatePicker
                                id="flightDate"
                                label="Requested Flight Date"
                                readOnly={editing!==true}
                                inputLabelProps={{shrink: true}}
                                minDate={newBooking ? moment().format("YYYY-MM-DD") : null}
                                disableToolbar={true}
                                autoOk={true}
                                format={dateFormat}
                                onChange={(returnValue, props) => {
                                  const data = {
                                    ...props.record,
                                    flightDate: returnValue,
                                    originDelivery: moment(returnValue).add(-3, 'days').format("YYYY-MM-DD")
                                  }
                                  props.recordChange(data);
                                }}
                              />
                              <Button
                                variant="text"
                                color="primary"
                                size="medium"
                                style={{marginLeft: 20, marginTop: 10}}
                                startIcon={<Icon>search_outlined</Icon>}
                                disabled={editing!==true || !record.charterOrigin || record.charterOrigin === "" || !record.destination || record.destination === ""}
                                onClick={()=>{eventBus.trigger("GetBookingFlightOptions.open", record);}}
                              >
                                Search Flights
                              </Button>
                            </div>
                          )}
                        </Grid>
                        <Grid item xs={4} checkChildren={true} >
                          {record=>(
                            <LightTooltip title={record.departureFlight || ""} >
                              <div className={"MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"} readonly="" style={{textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>
                                <label className={"MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"} dataShrink={true}>Departure Flight</label>
                                <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl readOnly" shrink="true">
                                  <div style={{ marginTop: 8, marginBottom: 5, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}} >
                                  {record.departureFlight || "Flight not selected yet"}
                                  </div>
                                </div>
                              </div>
                              {/*<TextField*/}
                              {/*  value={record.departureFlight}*/}
                              {/*  label="Departure Flight"*/}
                              {/*  readOnly={true}*/}
                              {/*  InputLabelProps={{ shrink: true }}*/}
                              {/*  style={{textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}}*/}
                              {/*  fullWidth*/}
                              {/*  InputProps={{*/}
                              {/*    readOnly: true,*/}
                              {/*    shrink: "true",*/}
                              {/*  }}*/}
                              {/*/>*/}
                            </LightTooltip>
                          )}
                        </Grid>
                        <Grid item xs={4} checkChildren={true} >
                          {record=>(
                            <DatePicker
                              id="originDelivery"
                              label={`Expected Delivery at ${operatorName} Departure Point`}
                              readOnly={editing!==true}
                              fullWidth
                              inputLabelProps={{shrink: true}}
                              minDate={record.flightDate ? moment(record.flightDate).add(-7,'days').format("YYYY-MM-DD") : undefined}
                              disableToolbar={true}
                              autoOk={true}
                              format={dateFormat}
                            />
                          )}
                        </Grid>
                        {/*<Grid item xs={4} />*/}
                      </Grid>
                    </Collapse>
                    {!collapse.flight
                      ? (record) => (<div>{renderFlightSummary(record)}</div>)
                      : <></>
                    }
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            {/*Shipment*/}
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper {...defaultLabelledPaperProps}
                             label="Shipment"
                             isOpened={collapse.shipment}
                             onClick={()=>setCollapse({...collapse, shipment: !collapse.shipment})}
              >
                <FormControl checkChildren={true} key="FC-shipment" style={{display: "block"}}>
                  <FormGroup checkChildren={true} key="FG-shipment" style={{padding: "8px 8px 8px 8px"}}>
                    <Collapse isOpened={collapse.shipment} checkChildren={true}>
                      <Grid container checkChildren={true} spacing={3}>
                        <Grid item xs={12} checkChildren={true}>
                          <FormCheckbox
                            id="consolidation"
                            label="Is this a pre-advice? (Please only tick this box if the dimensions are unknown at the time of booking. You will be required to update the dimensions once known)"
                            key="consolidation"
                            className={classes.checkbox}
                            readOnly={editing!==true}
                            labelPlacement={"end"}
                          />
                        </Grid>
                        {(record)=> {
                          if (record.consolidation)
                            return null;
                          else {
                            return(
                              <Grid item xs={12} checkChildren={true}>
                                <BookingDimensionsGrid
                                  id="dimensionsGrid"
                                  record={record}
                                  dimensions={record.dimensions}
                                  height={180}
                                  canEdit={editing}
                                  formMode={formMode}
                                  systemData={SystemData}
                                  defaults={{...defaults?.dimensions, cargoDoorHeightLimit: defaults?.cargoDoorHeightLimit, dimensionsUploadTemplate: defaults?.dimensionsUploadTemplate}}
                                  onGridReady={params=>{
                                    setDimensionsGridApi(params.api);
                                  }}
                                  onChange={(returnObject, props) =>{
                                    if (returnObject) {
                                      let data;
                                      if (__.has(returnObject, "switchToSpot") && returnObject.switchToSpot) {
                                        setSpotRequest(true);
                                      }
                                      if (formMode !== "SLR" && !spotRequest && !(__.has(returnObject, "switchToSpot") && !returnObject.switchToSpot)) {
                                        const {weight} = defaults;
                                        if (returnObject.actualWeight > Number(weight)) {
                                          SystemData.confirm(
                                            "Weight Limit Exceeded for Regular Booking",
                                            `Booking with Weight over ${weight}Kg require spot rate and review by ${operatorName}. Either transfer the booking to a 'Spot Request' by clicking 'YES' or reduce the total weight of the shipment particulars. Do you wish to transfer this booking to a Spot Request?`,
                                            [
                                              {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                                              {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                                            ],
                                            async (response) => {
                                              if (response) {
                                                setSpotRequest(true);
                                                data["spotRequest"] = true;
                                              }
                                            }
                                          );
                                        }
                                      }

                                      props.record.expectedChargeableWeight = returnObject.chargeableWeight;
                                      props.record.expectedWeightKg =  returnObject.actualWeight;
                                      const {baseToUsd, baseToGbp, baseToEur} = props.record.gsaCurrencyRates || {baseToUsd: 0, baseToGbp: 0, baseToEur: 0};
                                      updateRateLines(props.record.rates, returnObject.actualWeight, returnObject.chargeableWeight, props.record.gsaDefaultCurrencyCode, baseToUsd)
                                      const {eurTotalAmount, gbpTotalAmount, usdTotalAmount} = getTotals(props.record.rates, props.record.gsaDefaultCurrencyCode,baseToEur, baseToGbp);
                                      const expectedChargeableWeight = getChargeableWeight(returnObject.actualWeight, returnObject.volume);
                                      data = {
                                        ...props.record,
                                        expectedPieces: returnObject.pieces,
                                        expectedWeightKg: returnObject.actualWeight,
                                        expectedVolume: returnObject.volume,
                                        shipmentParticulars: returnObject.shipmentParticulars,
                                        dimensions: returnObject.shipmentParticulars,
                                        volumetricWeight: getVolumetricWeight(returnObject.volume),
                                        expectedChargeableWeight: expectedChargeableWeight,
                                        ratio: getWeightVolumeRatio(returnObject.volume, returnObject.actualWeight),
                                        spotChargeableWeight: !props.record.overrideChargeableWeight ? expectedChargeableWeight : props.record.spotChargeableWeight,
                                        eurTotalAmount,
                                        gbpTotalAmount,
                                        usdTotalAmount,
                                      }

                                      if (__.has(returnObject, "switchToSpot") && returnObject.switchToSpot) {
                                        data["spotRequest"] = true;
                                      }

                                      if (JSON.stringify(props.record) !== JSON.stringify(data)) {
                                        // console.log('refreshing dims grid');
                                        props.recordChange(data);
                                        if (ratesGridApi) {
                                          ratesGridApi.refreshCells({force: true, suppressFlash: false});
                                        }
                                      }
                                    }
                                  }}
                                />
                              </Grid>
                            )
                          }
                        }}
                        <Grid item xs={2} checkChildren={true}>
                          {record=>(
                            <MaskedNumber
                              id="expectedPieces"
                              label="Pieces"
                              readOnly={editing!==true || !record.consolidation}
                              //inputLabelProps={{shrink: true}}
                              decimalScale={0}
                              fixedDecimalScale={true}
                              valueCap={9999}
                              fullWidth
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkChildren={true}>
                          {record=>(
                            <MaskedNumber
                              id="expectedWeightKg"
                              label="Weight"
                              // readOnly={editing!==true || !record.consolidation}
                              readOnly={editing!==true} // TODO: should this be smarter and check if weight was provided by dimensions grid?
                              //inputLabelProps={{shrink: true}}
                              decimalScale={1}
                              fixedDecimalScale={true}
                              valueCap={150000}
                              suffix=" kg"
                              fullWidth
                              onChange={(value, props) =>{
                                if (formMode !== "SLR" && !spotRequest) {
                                  const {weight} = defaults;
                                  if (value > Number(weight)) {
                                    SystemData.confirm(
                                      "Weight Limit Exceeded for Regular Booking",
                                      `Booking with Weight over ${weight}Kg require spot rate and review by ${operatorName}. Either transfer the booking to a 'Spot Request' by clicking 'YES' or reduce the total weight of the shipment particulars. Do you wish to transfer this booking to a Spot Request?`,
                                      [
                                        {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                                        {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
                                      ],
                                      async (response) => {
                                        if (response) {
                                          setSpotRequest(true);
                                          data["spotRequest"] = true;
                                        } else {
                                          value = 0;
                                          const expectedChargeableWeight = getChargeableWeight(value, props.record.expectedVolume);
                                          const data = {
                                            ...props.record,
                                            expectedWeightKg: value,
                                            expectedChargeableWeight,
                                            ratio: getWeightVolumeRatio(props.record.expectedVolume, value),
                                            spotChargeableWeight: !props.record.overrideChargeableWeight ? expectedChargeableWeight : props.record.spotChargeableWeight,
                                          }
                                          props.recordChange(data);
                                        }
                                      }
                                    );
                                  }
                                }

                                const expectedChargeableWeight = getChargeableWeight(value, props.record.expectedVolume);
                                const data = {
                                  ...props.record,
                                  expectedWeightKg: value,
                                  expectedChargeableWeight,
                                  ratio: getWeightVolumeRatio(props.record.expectedVolume, value),
                                  spotChargeableWeight: !props.record.overrideChargeableWeight ? expectedChargeableWeight : props.record.spotChargeableWeight,
                                }
                                props.recordChange(data);
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkChildren={true}>
                          {record=>(
                            <MaskedNumber
                              id="expectedVolume"
                              label="Volume"
                              readOnly={editing!==true || !record.consolidation}
                              //inputLabelProps={{shrink: true}}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              suffix=" CBM"
                              valueCap={1000}
                              fullWidth
                              onChange={(value, props) =>{
                                const expectedChargeableWeight = getChargeableWeight(props.record.expectedWeightKg, value);
                                const volumetricWeight = getVolumetricWeight(value);
                                const data = {
                                  ...props.record,
                                  expectedVolume: value,
                                  expectedChargeableWeight,
                                  volumetricWeight,
                                  ratio: getWeightVolumeRatio(value, props.record.expectedWeightKg),
                                  spotChargeableWeight: !props.record.overrideChargeableWeight ? expectedChargeableWeight : props.record.spotChargeableWeight
                                }
                                props.recordChange(data);
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkChildren={true}>
                          <MaskedNumber
                            id="volumetricWeight"
                            label="Volumetric Weight"
                            readOnly={true}
                            //inputLabelProps={{shrink: true}}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            suffix=" KG"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={2} checkChildren={true}>
                          {record=>(
                            <MaskedNumber
                              id="expectedChargeableWeight"
                              label="Chargeable Weight"
                              readOnly={true}
                              //inputLabelProps={{shrink: true}}
                              decimalScale={1}
                              fixedDecimalScale={true}
                              suffix=" KG"
                              valueCap={150000}
                              fullWidth
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkChildren={true}>
                          <MaskedText
                            id="ratio"
                            label="Weight / Volume Ratio"
                            inputLabelProps={{shrink: true}}
                            readOnly={true}
                            fullWidth
                            mask={"x".repeat(100)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                          />
                        </Grid>
                      </Grid>
                    </Collapse>
                    {!collapse.shipment
                      ? (record) => (<div>{renderShipmentSummary(record)}</div>)
                      : <></>
                    }
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            {/*Shipment Declaration*/}
            {formMode !== "SLR" ? renderShipmentDeclaration() : <></>}

            {/*Documents*/}
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper {...defaultLabelledPaperProps}
                             label="Documents"
                             isOpened={collapse.documents}
                             onClick={()=>setCollapse({...collapse, documents: !collapse.documents})}
              >
                <FormControl checkChildren={true} key="FC-documents" style={{display: "block"}}>
                  <FormGroup checkChildren={true} key="FG-documents" style={{padding: "8px 8px 8px 8px"}}>
                    <Collapse isOpened={collapse.documents} checkChildren={true}>
                      <Grid item xs={12} checkChildren={true} id="documentGridContainer">
                        {record => (
                          <BookingDocumentsGrid
                            id="documentsGrid"
                            awbNumber={`${record.awbPrefix && record.awbSerial ? record.awbPrefix-record.awbSerial : "000-00000000"}`}
                            documents={record.documents}
                            height={180}
                            canEdit={editing}
                            onGridReady={params => {
                              setDocumentsGridApi(params.api);
                            }}
                            onChange={(documents, props) => {
                              if (documents) {
                                const data = {
                                  ...props.record,
                                  documents: documents,
                                }
                                if (JSON.stringify(documents) !== JSON.stringify(record.documents))
                                  props.recordChange(data);
                              }
                            }}
                          />
                        )}
                      </Grid>
                    </Collapse>
                    {!collapse.documents
                      ? (record) => (<div>{renderDocumentsSummary(record)}</div>)
                      : <></>
                    }
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            {/*Spot Rate Request*/}
            {spotRequest
              ?
              <Grid item xs={12} checkChildren={true}>
                <LabelledPaper {...defaultLabelledPaperProps}
                               label="Spot"
                               isOpened={collapse.spot}
                               onClick={()=>setCollapse({...collapse, spot: !collapse.spot})}
                >
                  <FormControl checkChildren={true} key="FC-spot" style={{display: "block"}}>
                    <FormGroup checkChildren={true} key="FG-spot" style={{padding: "8px 8px 8px 8px"}}>
                      <Collapse isOpened={collapse.spot} checkChildren={true}>
                        <Grid container checkChildren={true} spacing={3}>

                          <Grid item xs={2} checkChildren={true}>
                            {record=>(
                              <MaskedNumber
                                id="customerTargetRate"
                                label={`${formMode === "OPERATOR" ? "Customer" : ""} Target Rate`}
                                readOnly={editing!==true}
                                //inputLabelProps={{shrink: true}}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                valueCap={9999}
                                fullWidth
                              />
                            )}
                          </Grid>
                          {formMode === "OPERATOR"
                            ?
                              <Fragment checkChildren={true}>
                                <Grid item xs={2} checkChildren={true}>
                                  <FormCheckbox
                                    id="overrideChargeableWeight"
                                    label="Override Chargeable Weight"
                                    key="overrideChargeableWeight"
                                    className={classes.checkbox}
                                    readOnly={editing!==true}
                                    labelPlacement={"end"}
                                    onChange={(value, props) => {
                                      const data = {
                                        ...props.record,
                                        overrideChargeableWeight: value,
                                        spotChargeableWeight: value ? props.record.spotChargeableWeight : props.record.expectedChargeableWeight,
                                      }
                                      props.recordChange(data);
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={2} checkChildren={true}>
                                  {record =>(
                                    <MaskedNumber
                                      id="spotChargeableWeight"
                                      label="Spot Chargeable Weight"
                                      readOnly={!record.overrideChargeableWeight}
                                      //inputLabelProps={{shrink: true}}
                                      decimalScale={1}
                                      fixedDecimalScale={true}
                                      suffix=" KG"
                                      valueCap={150000}
                                      fullWidth
                                    />)
                                  }
                                </Grid>
                                <Grid item xs={2} checkChildren={true}>
                                  {record=>(
                                    <MaskedNumber
                                      id="offeredSpotRate"
                                      label="Offer Target Rate"
                                      readOnly={editing!==true}
                                      //inputLabelProps={{shrink: true}}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      valueCap={9999}
                                      fullWidth
                                    />
                                  )}
                                </Grid>
                              </Fragment>
                            :
                              <></>
                          }
                          <Grid item xs={10} checkChildren={true}>
                            {record=>(<div>{ renderSpotRateRevenue(record)} </div>)}
                          </Grid>
                        </Grid>
                      </Collapse>
                      {!collapse.spot
                        ? (record) => (<div>{renderSpotRate(record)}</div>)
                        : <></>
                      }
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              :
              <></>
            }


            {/*Rates*/}
            {formMode === "OPERATOR"
              ?
              <Grid item xs={12} checkChildren={true}>
                <LabelledPaper {...defaultLabelledPaperProps}
                               label="Rate Calculation"
                               isOpened={collapse.rates}
                               onClick={()=>setCollapse({...collapse, rates: !collapse.rates})}
                >
                  <FormControl checkChildren={true} key="FC-rate-calculation" style={{display: "block"}}>
                    <FormGroup checkChildren={true} key="FG-rate-calculation" style={{padding: "8px 8px 8px 8px"}}>
                      <Collapse isOpened={collapse.rates} checkChildren={true}>
                        <Grid container checkChildren={true} spacing={3}>
                          <Grid item xs={4} checkChildren={true}>
                            {(record) => (
                              <CurrencySelector
                                id="gsaDefaultCurrencyCode"
                                returnType="object"
                                label={`Base Currency ${record.gsaCompanyName ? "for " : ""}${record.gsaCompanyName ? record.gsaCompanyName : ""}`}
                                readOnly={true}
                                inputLabelProps={{shrink: true}}
                                fullWidth
                                onChange={(returnObject, props) => {
                                  if (returnObject.found) {
                                    const currency = returnObject.data
                                    const data = {
                                      ...props.record,
                                      gsaDefaultCurrencyCode: currency.currencyCode,
                                      gsaDefaultCurrencyName: currency.currencyName,
                                    }
                                    props.recordChange(data);
                                  } else {
                                    props.onChange(returnObject.value);
                                  }
                                }}
                              />
                            )}
                          </Grid>
                          <Grid item xs={4} checkChildren={true}>
                            <MaskedText
                              id="gsaDefaultCurrencyName"
                              label="Currency Name"
                              readOnly={true}
                              inputLabelProps={{shrink: true}}
                              fullWidth
                              mask={"x".repeat(100)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={formatChars}
                            />
                          </Grid>
                          <Grid item xs={12} checkChildren={true}>
                            {(record)=>(
                              record.gsaCompanyUuid && record.expectedChargeableWeight && record.expectedWeightKg
                                ?
                                <BookingRatesGrid
                                  rates={record.rates}
                                  height={92}
                                  canEdit={editing}
                                  record={record}
                                  onGridReady={params=>{
                                    setRatesGridApi(params.api);
                                    params.api.refreshCells({force: true, suppressFlash: false});
                                    setTimeout(function() {
                                      params.api.refreshCells({force: true, suppressFlash: false});
                                    }, 500);
                                  }}
                                  onChange={(returnObject, props) =>{
                                    if (returnObject) {
                                      const data = {
                                        ...props.record,
                                        eurTotalAmount: returnObject.eurTotalAmount,
                                        gbpTotalAmount: returnObject.gbpTotalAmount,
                                        usdTotalAmount: returnObject.usdTotalAmount,
                                        rates: returnObject.rateLines,
                                      }
                                      if (JSON.stringify(data) !== JSON.stringify(record))
                                        props.recordChange(data);
                                    }
                                  }}
                                />
                                :
                                <div key={"noRatesAvailable"} style={{textAlign: "center"}}>
                              <span key={"noRatesAvailableError"} style={{padding: "10px", border: "1px solid #111", background: "#fdecea"}}>
                                Detailed rate calculation is only available when a GSA and cargo particulars are provided for the booking
                              </span>
                                </div>
                            )}
                          </Grid>
                          <Grid item xs={6} key={"rates-spacer-1"}/>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedNumber
                              id="eurTotalAmount"
                              label="Total Amount EUR"
                              readOnly={true}
                              style={{textAlign: "right"}}
                              inputLabelProps={{shrink: true}}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              fullWidth
                              prefix="€ "
                            />
                          </Grid>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedNumber
                              id="gbpTotalAmount"
                              label="Total Amount GBP"
                              readOnly={true}
                              style={{textAlign: "right"}}
                              inputLabelProps={{shrink: true}}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              fullWidth
                              prefix="£ "
                            />
                          </Grid>
                          <Grid item xs={2} checkChildren={true}>
                            <MaskedNumber
                              id="usdTotalAmount"
                              label="Total Amount USD"
                              readOnly={true}
                              style={{textAlign: "right"}}
                              inputLabelProps={{shrink: true}}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              fullWidth
                              prefix="$ "
                            />
                          </Grid>
                        </Grid>
                      </Collapse>
                      {!collapse.rates
                        ? (record) => (<div>{renderRatesSummary(record)}</div>)
                        : <></>
                      }
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>
              : null
            }


            {/*Other Info*/}
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper {...defaultLabelledPaperProps}
                             label="Other Info"
                             isOpened={collapse.info}
                             onClick={()=>setCollapse({...collapse, info: !collapse.info})}
              >
                <FormControl checkChildren={true} key="FC-other" style={{display: "block"}}>
                  <FormGroup checkChildren={true} key="FG-other" style={{padding: "8px 8px 8px 8px"}}>
                    <Collapse isOpened={collapse.info} checkChildren={true}>
                      <Grid container checkChildren={true} spacing={3}>
                        <Grid item xs={12} checkChildren={true}>
                          <FormMemo
                            id="note"
                            label="Notes"
                            readOnly={editing!==true}
                            shrink={true}
                          />
                        </Grid>
                        {/*{formMode === "OPERATOR" ? <Grid item xs={12} key={"notes-spacer-1"}/> : <></> }*/}
                        {formMode === "OPERATOR"
                          ?
                            <Grid item xs={12} checkChildren={true}>
                              <FormMemo
                                id="financeComments"
                                label="Finance Notes"
                                readOnly={editing!==true}
                                shrink={true}
                              />
                            </Grid>
                          :
                            <></>
                        }
                        {formMode === "OPERATOR"
                          ?
                            <Grid item xs={12} checkChildren={true}>
                              <FormMemo
                                id="loadabilityNotes"
                                label="Loadability Notes"
                                readOnly={editing!==true}
                                shrink={true}
                              />
                            </Grid>
                          :
                            <></>
                        }
                      </Grid>
                    </Collapse>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            {/*Confirmation*/}
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper {...defaultLabelledPaperProps}
                             label="Confirmation"
                             isOpened={collapse.confirmation}
                             onClick={()=>setCollapse({...collapse, confirmation: !collapse.confirmation})}
              >
                <FormControl checkChildren={true} key="FC-confirm" style={{display: "block"}}>
                  <FormGroup checkChildren={true} key="FG-confirm" style={{padding: "8px 8px 8px 8px"}}>
                    <Collapse isOpened={collapse.confirmation} checkChildren={true}>
                      <Grid container checkChildren={true} spacing={3}>
                        <Grid item xs={2} checkChildren={true}>
                          <FormCheckbox
                            id="termsAccepted"
                            label={newBooking ? "Accept Terms & Conditions" : "Terms & Conditions Accepted"}
                            key="termsAccepted"
                            className={classes.checkbox}
                            readOnly={editing!==true}
                          />
                        </Grid>
                        <Grid item xs={10} checkChildren={true}>
                          {(record) => (
                            <TextField
                              id="terms"
                              label="Terms and Conditions for this Booking"
                              readOnly={true}
                              shrink="true"
                              InputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              fullWidth
                              InputProps={{
                                readOnly: true,
                                shrink: "true",
                                endAdornment:
                                  <InputAdornment position="end">
                                    <Link to={{pathname: record.termsUrl}} target="_blank" rel="noopener noreferrer">
                                      <IconButton
                                        aria-label="Open in browser"
                                        edge="end"
                                      >
                                        {record.termsUrl ? <OpenInBrowser /> : <></>}
                                      </IconButton>
                                    </Link>
                                  </InputAdornment>
                              }}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Collapse>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>

            {(record, changeRecord) =>
              {
                return (record.charterOrigin && record.charterOrigin !== "" && record.destination && record.destination !== ""
                    ?
                      <FlightOptions
                        close={(flightDate, departureFlight, trips, flights)=>{
                          const originDelivery = moment(flightDate ).add(-3, 'days').format("YYYY-MM-DD")
                          changeRecord({flightDate, originDelivery, departureFlight, viaRouting: {departureFlight, trips, flights} });
                        }}
                      />
                    :
                      <></>
                )
              }
            }

          </Grid> {/*Container*/}
        </NewBookingDialog>
        : <></>
      }
    </div>
  );
}

export default BookingForm;
